import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../../../../../libs/core/auth/auth.service';

export const portalAuthCanMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) return true;

  authService.hydrate();

  if (authService.isAuthenticated() && authService.hasRole('customer')) {
    return true;
  }

  return router.parseUrl('/login');
};
